
import { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Container, useTheme, TableContainer, Card, Table, TableBody, CircularProgress, Box, alpha, Tabs } from '@mui/material';
import { useSettingsContext } from '../../components/settings/index.js';
import { useTable, TableHeadCustom, TablePaginationCustom } from '../../components/table/index.js';
import CustomBreadcrumbs from '../../components/custom-breadcrumbs/index.js';
import { RouterLink } from '../../routes/components/index.js';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from '../../components/snackbar/index.js';
import Iconify from '../../components/iconify/iconify.js';
import SubscriptionTableRow from './summary-table-row.js';
import SubscriptionTableToolBar from './summary-table-toolbar.js';
import {exportDataSummaryToCSV} from '../../util/exportSummary.js';


// GRAPHQL
import { GET_ALL_SUBSCRIPTION, DELETE_SUBSCRIPTION } from "../../graphql/modules/subscription.js";
import { GET_ALL_SUMMARY } from 'src/graphql/modules/summary.js';
import { useQuery, useMutation } from "@apollo/react-hooks";

const STATUS_OPTION = [
  { value: 'all', label: 'All' },
  // {value: 'Enhanced', label: 'Enhanced'},
  // {value: 'Standard', label: 'Standard'},
  // {value: 'Avanced', label: 'Avanced'}
]
const TABLE_HEAD = [
  { id: 'databaseName', label: 'Training Provider' },
  { id: 'confirmedTraineesByMonth.1', label: 'Jan' },
  { id: 'confirmedTraineesByMonth.2', label: 'Feb' },
  { id: 'confirmedTraineesByMonth.2', label: 'Mar' },
  { id: 'confirmedTraineesByMonth.2', label: 'Apr' },
  { id: 'confirmedTraineesByMonth.2', label: 'May' },
  { id: 'confirmedTraineesByMonth.2', label: 'Jun' },
  { id: 'confirmedTraineesByMonth.2', label: 'Jul' },
  { id: 'confirmedTraineesByMonth.2', label: 'Aug' },
  { id: 'confirmedTraineesByMonth.2', label: 'Sep' },
  { id: 'confirmedTraineesByMonth.2', label: 'Oct' },
  { id: 'confirmedTraineesByMonth.2', label: 'Nov' },
  { id: 'confirmedTraineesByMonth.2', label: 'Dec' },
  { id: 'totalConfirmedClasses', label: 'Total Confirmed Class' },
  { id: 'diskSizeMB', label: 'Total Disk Size' },
]

const defaultFilters = {
  name: '',
  subscription: 'Standard',
  year: new Date(),
  status: 'all'
}

export function SummaryListView({ img, ...other }) {
  const { fullName } = useSelector((state) => state?.auth?.user);
  const theme = useTheme();
  const table = useTable();
  const navigate = useNavigate();
  const settings = useSettingsContext();
  const [filters, setFilters] = useState(defaultFilters);
  const [searchText, setSearch] = useState("");
  const [companyName, setCompanyName] = useState("iatos");
  const [page, setPage] = useState(1);
  const [subscription, setSubscription] = useState(null);
  const [summary, setSummary] = useState(null);
  const [DeleteSubscriptionMutation] = useMutation(DELETE_SUBSCRIPTION);
  const { enqueueSnackbar } = useSnackbar();
  const [loadingCircle, setLoading] = useState(true);

  const { data, loading, error, refetch } = useQuery(GET_ALL_SUBSCRIPTION, {
    variables: {
      limit: table?.rowsPerPage,
      offset: table?.page,
      searchText: "",
      companyName: companyName,
      order: table.order,
      orderBy: table.orderBy || 'createdDate'
    },
    fetchPolicy: "cache-and-network",
  });

  const { data: resSummary, refetch: refSummary } = useQuery(GET_ALL_SUMMARY, {
    variables: {
      limit: null,
      offset: null,
      searchText: null,
      companyName: null,
      order: null,
      orderBy: null,
      title: filters?.subscription,
      year: filters?.year.getFullYear()
    },
    fetchPolicy: "cache-and-network",
  });





  useEffect(() => {
    if (data) {
      setSubscription(data?.getAllSubscription)
    }


  }, [data])

  useEffect(() => {
    if (resSummary) {
      setSummary(resSummary.getAllSummary);
    }
    setLoading(false);

  }, [resSummary])

  const handleFilters = useCallback((name, value) => {
    setSummary(null)
    setFilters(prevState => ({
      ...prevState,
      [name]: value
    }));
    
  }, [table]);

  const handleDeleteRow = useCallback(async (id) => {
    const { data: { deleteSubscription } } = await DeleteSubscriptionMutation({
      variables: {
        _id: id,
        companyName: "iatos",
        fullName: fullName
      }
    })

    if (deleteSubscription?.success) {
      enqueueSnackbar('Deleted success!', { variant: 'success' });
      refetch();
    } else {
      enqueueSnackbar('Failed to delete!', { variant: 'error' });
    }
  },
    [refetch]
  );


  const handleViewAccount = useCallback((row) => {
    navigate('/subscription-details', { state: row })
  },
    []
  );
  const handleEditRow = useCallback((row) => {
    navigate('/subscription-create-update', { state: row })
  });

const onExportCSV = async () => {
  exportDataSummaryToCSV(summary?.results, `Summary ${filters?.subscription} ${filters?.year.getFullYear()}`)
};


  return (

    <Container maxWidth={settings.themeStretch ? false : 'xl'}>
      <CustomBreadcrumbs
        heading="Summary List"
        links={[
          { name: 'Dashboard' },
          { name: 'Summary' },
          { name: 'List' }
        ]}
        action={undefined}
      />


      <Card>
         <Tabs 
          value={filters}
          sx={{
            px: 2.5,
            boxShadow: (theme) => `inset 0 -2px 0 0 ${alpha(theme.palette.grey[500], 0.08)}`
          }}
         >
   

         </Tabs>

        <SubscriptionTableToolBar onFilters={handleFilters} filters={filters} subscription={subscription} onExportCSV={onExportCSV}/>

        {!summary ? (<Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
        </Box>)
          :

          <>
            <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
              <Table sx={{ minWidth: 960 }}>

                <TableHeadCustom
                  headLabel={TABLE_HEAD}
                  order={table.order}
                  orderBy={table.orderBy}
                  onSort={table.onSort}
                />



                <TableBody>

                  {summary?.results?.map((row) => (
                    <SubscriptionTableRow
                      key={row?.id}
                      row={row}
                      onViewRow={() => handleViewAccount(row)}
                      onDeleteRow={() => handleDeleteRow(row._id)}
                      onEditRow={() => handleEditRow(row)}
                    />
                  ))}


                </TableBody>

              </Table>
            </TableContainer>
            <TablePaginationCustom
              count={summary?.count}
              page={table.page}
              rowsPerPage={table.rowsPerPage}
              onPageChange={table.onChangePage}
              onRowsPerPageChange={table.onChangeRowsPerPage}
            />
          </>

        }

      </Card>

    </Container>

  );
}